<template>
  <div class="m-card-primary m-the-modal-content">
    <form
      autocomplete="off"
      name="the-modal-form"
      @submit.prevent="createAcademiaUsuario"
    >
      <header class="m-the-modal-header">
        <h5>{{ $t('mEditionAcademyUsersModalCreate.title') }}</h5>
        <AtomButtonTheModalCloseIcon/>
      </header>
      <section class="m-the-modal-section">
        <AtomSelectPrimary
          v-model.number="registracion.actor"
          :elements="tipoActores"
          :inputError="$v.registracion.actor.$error"
          keyField="id"
          :label="$t('mEditionAcademyUsersModalCreate.inputs.actor.label')"
          :messageError="messageErrorActor"
          name="actor"
          textField="name"
          @blur="$v.registracion.actor.$touch()"
        />
        <AtomInputPrimary
          v-model="registracion.email"
          :inputError="$v.registracion.email.$error"
          :label="$t('mEditionAcademyUsersModalCreate.inputs.email.label')"
          :messageError="messageErrorEmail"
          name="email"
          :placeholder="$t('mEditionAcademyUsersModalCreate.inputs.email.placeholder')"
          type="text"
          @blur="$v.registracion.email.$touch()"
        />
      </section>
      <footer class="m-the-modal-footer">
        <AtomButtonTheModalCancelAction :cancel-text="$t('mEditionAcademyUsersModalCreate.buttonCancel')"/>
        <AtomButtonPrimary :button-primary="buttonPrimary"/>
      </footer>
    </form>
  </div>
</template>

<script>
import { email, required, integer } from 'vuelidate/lib/validators'

export default {
  name: 'MoleculeEditionAcademyUsersModalCreate',

  data () {
    return {
      buttonPrimary: {
        action: this.$t('mEditionAcademyUsersModalCreate.buttonPrimary'),
        class: 'a-button-academy-primary',
        sending: false,
        type: 'submit'
      },

      registracion: {
        actor: '',
        email: ''
      },

      showLoadingState: true,
      tipoActores: []
    }
  },

  validations: {
    registracion: {
      actor: {
        required,
        integer
      },

      email: {
        email,
        required
      }
    }
  },

  computed: {
    messageErrorActor () {
      return this.$validation.getValidationMessage('mEditionAcademyUsersModalCreate', this.$v.registracion.actor, 'actor')
    },

    messageErrorEmail () {
      return this.$validation.getValidationMessage('mEditionAcademyUsersModalCreate', this.$v.registracion.email, 'email')
    }
  },

  watch: {
    'registracion.email' () {
      this.registracion.email = this.registracion.email.toLowerCase()
    }
  },

  created () {
    this.tipoActores = [...this.$filters.parameters.actors]
    this.tipoActores.shift()
  },

  methods: {
    createAcademiaUsuario () {
      this.$v.$touch()
      if (!this.$v.$invalid && !this.buttonPrimary.sending) {
        let actorTipo = ''
        switch (this.registracion.actor) {
          case 0:
            actorTipo = 'alumnos'
            break
          case 1:
            actorTipo = 'profesores'
            break
          case 2:
            actorTipo = 'administradores'
            break
          case 7:
            actorTipo = 'instructores'
            break
        }
        if (this.$license.isMaximumReached(actorTipo)) {
          this.$modal.showModal('MoleculeLicenseModalUpgrade', actorTipo)
        } else {
          this.buttonPrimary.sending = true
          this.$services.create('academia', 'createAcademiaUsuario', this.registracion, [this.$store.getters.getAcademyData.id])
            .then(response => {
              if (response.data.message !== undefined) {
                switch (response.data.message) {
                  case 'El Rol que desea crear ya existe':
                    if (response.data.actor.habilitado === 1) {
                      this.$alerts.pushAlert('mEditionAcademyUsersModalCreate', 'createAcademiaUsuario', 'rolExistenteHabilitado')
                    } else {
                      this.$alerts.pushAlert('mEditionAcademyUsersModalCreate', 'createAcademiaUsuario', 'rolExistenteDeshabilitado')
                    }
                    break

                  case 'Se creo el nuevo Rol, ya que el usuario ya pertenecia a la academia':
                    this.$modal.updateData()
                    this.$alerts.pushAlert('mEditionAcademyUsersModalCreate', 'createAcademiaUsuario', 'rolInmediato')
                    break
                }
              } else {
                this.$modal.updateData()
                this.$alerts.pushAlert('mEditionAcademyUsersModalCreate', 'createAcademiaUsuario', 'success')
              }
              this.$modal.closeModal()
              this.readAcademiaRecursosUsados()
              this.buttonPrimary.sending = false
            })
            .catch(error => {
              console.log(error)
              this.readAcademiaRecursosUsados()
              this.$alerts.pushAlert('mEditionAcademyUsersModalCreate', 'createAcademiaUsuario', 'error', 'a-alert-danger')
              this.buttonPrimary.sending = false
            })
        }
      }
    },

    readAcademiaRecursosUsados () {
      this.$license.readAcademiaRecursosUsados()
    }
  }
}
</script>
